import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const ModalEmailConfirmations = ({ modal, toggle, surveyId }) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [confirmations, setConfirmations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (modal && surveyId) {
            loadConfirmations();
        }
    }, [modal, surveyId]);

    const loadConfirmations = () => {
        setLoading(true);
        fetch(`/email_confirmations/${surveyId}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                setConfirmations(data.confirmations);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error:", error);
                setLoading(false);
            });
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getEmailTypeBadge = (type) => {
        const types = {
            'interno': { text: 'Interno', class: 'badge-primary' },
            'externo': { text: 'Externo', class: 'badge-info' },
            'responsabilidad': { text: 'Responsabilidad', class: 'badge-warning' }
        };
        const typeInfo = types[type] || { text: type, class: 'badge-secondary' };
        return <span className={`badge ${typeInfo.class}`}>{typeInfo.text}</span>;
    };

    const getStatusBadge = (confirmed) => {
        return confirmed ?
            <span className="badge badge-success">✓ Confirmado</span> :
            <span className="badge badge-secondary">Pendiente</span>;
    };

    return (
        <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Confirmaciones de Correo
            </ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="text-center p-4">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Cargando...</span>
                        </div>
                    </div>
                ) : confirmations.length === 0 ? (
                    <div className="alert alert-info">
                        No hay confirmaciones de correo para este registro.
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>Tipo</th>
                                    <th>Destinatario</th>
                                    <th>Estado</th>
                                    <th>Enviado</th>
                                    <th>Confirmado</th>
                                    <th>IP</th>
                                </tr>
                            </thead>
                            <tbody>
                                {confirmations.map((conf) => (
                                    <tr key={conf.id}>
                                        <td>{getEmailTypeBadge(conf.email_type)}</td>
                                        <td className="text-truncate" style={{ maxWidth: '200px' }}>
                                            {conf.recipient_email}
                                        </td>
                                        <td>{getStatusBadge(conf.confirmed)}</td>
                                        <td className="text-muted small">{formatDate(conf.created_at)}</td>
                                        <td className="text-muted small">{formatDate(conf.confirmed_at)}</td>
                                        <td className="text-muted small">{conf.ip_address || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="mt-3">
                    <button className="btn btn-secondary" onClick={toggle}>
                        Cerrar
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalEmailConfirmations;
